import { AxiosInstance } from 'axios';
import { ShiftCategoriesOrderRepository } from '@/model/repository/shift/ShiftCategoriesOrderRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftCategoriesOrderRepository => ({
    update(payload) {
      return Repository.put(resource, payload);
    },
  });
